import React, { createContext, useState } from "react";

export const SelectionContext = createContext();

const StoreContext = ({ children }) => {

    const [updateProfile, setUpdateProfile] = useState(false);

    return (
        <SelectionContext.Provider value={{ updateProfile, setUpdateProfile }}>
            {children}
        </SelectionContext.Provider>
    )

}
export default StoreContext